<div class="tile-kpi-wrapper">
  <div class="tile-kpi">
    <span class="tile-kpi-value" [ngStyle]="{ color: this.data.value_color }">
      {{ data.value }}
    </span>
    <span class="tile-kpi-frame">{{ data.frame }}</span>
    <h3>{{ data.title }}</h3>
  </div>
</div>
